import React from 'react';
import { Card, Row, Col, Statistic, Empty } from 'antd';

const ProjectBreakdown = ({ data, loading }) => {
  if (loading || !data || !data.projects) {
    return null;
  }

  const { projects } = data;

  // Filter out statuses and phases with no projects
  const activeStatuses = projects.statuses.filter((status) => status.count > 0);
  const activePhases = projects.phases.filter((phase) => phase.count > 0);

  if (activeStatuses.length === 0 && activePhases.length === 0) {
    return (
      <Card title="Project Breakdown" style={{ marginBottom: 24 }}>
        <Empty description="No projects yet" />
      </Card>
    );
  }

  return (
    <Card title="Project Breakdown" style={{ marginBottom: 24 }}>
      <Row gutter={[16, 16]}>
        {activeStatuses.length > 0 && (
          <Col xs={24} lg={12}>
            <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Status</h3>
            <Row gutter={[16, 16]}>
              {activeStatuses.map((status) => (
                <Col xs={12} sm={8} key={status.key}>
                  <Card
                    size="small"
                    style={{
                      textAlign: 'center',
                      borderTop: '2px solid #1890ff',
                    }}
                  >
                    <Statistic
                      title={status.title}
                      value={status.count}
                      valueStyle={{ fontSize: 24, color: '#1890ff' }}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        )}

        {activePhases.length > 0 && (
          <Col xs={24} lg={12}>
            <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Phase</h3>
            <Row gutter={[16, 16]}>
              {activePhases.map((phase) => (
                <Col xs={12} sm={8} key={phase.key}>
                  <Card
                    size="small"
                    style={{
                      textAlign: 'center',
                      borderTop: '2px solid #52c41a',
                    }}
                  >
                    <Statistic
                      title={phase.title}
                      value={phase.count}
                      valueStyle={{ fontSize: 24, color: '#52c41a' }}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default ProjectBreakdown;
